import React, { useState, useEffect } from 'react';
import { Accordion, Card, OverlayTrigger, Spinner, Tooltip } from 'react-bootstrap';
import Select from 'react-select';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { isEmpty } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { SelectBoxStyles } from '../../Components/helper';
import Loader from '../../Components/Utility/Loader/Loader';
import BtnAdd from '../../Components/Utility/FilterAction/BtnAdd';
import * as action from './Store/SystemMasters.action';
import ConfirmationPopup from '../../Components/ModalPopup/ConfirmationPopup';
import { useComponent } from '../UserSetting/UsersLibrary/UserRights';
import CustomTooltip from '../../Components/Tooltip/CustomTooltip';

const tempObj = {
  name: null,
  isEmpty: false,
  isActive: true,
  bomTypeID: '',
  bomsubTypeId: '',
  _id: '',
};

function BomSubComponentTypeMaster() {
  const dispatch = useDispatch();
  const reducer = useSelector((estate) => estate);
  const [isBOMST, setIsBOMST] = useState(false);

  const {
    SystemMastersDetails,
    UserDetails,
    Users: { logInRights },
  } = reducer;
  const { BOMTypeList, BOMComTypeList, bomSubComponentType, category3ListFrom4 } = SystemMastersDetails;
  const { userInfo } = UserDetails;
  const { t } = useTranslation('common');
  const loggedInUserId = userInfo.userId;
  const [scrollEl, setScrollEl] = useState();
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [isLoadingConf, setIsLoadingConf] = useState(false);
  const [buttonDownBomType, setButtonDownBomType] = useState(true);
  const [isLoadingBSTM, setIsLoadingBSTM] = useState(false);
  const [showBomType, setShowBomType] = useState(false);
  const [bomSubCompTypeData, setBomCompSubTypeData] = useState([]);
  const [isBomTypeUnique, setIsBomTypeUnique] = useState(true);
  const { CheckActionPermission } = useComponent();
  const [userRights, setUserRights] = useState({});
  const [bomSubTypeSelectData, setbomSubTypeSelectData] = useState(null);
  const [bomCompData, setBomCompData] = useState(null);
  const [showConfirmationAD, setShowConfirmationAD] = useState(false);
  const [activeInactiveID, setActiveInactiveID] = useState('');
  const [isUniqBTDId, setIsUniqBTDId] = useState([]);
  const [bomCompTypeData, setBomCompTypeData] = useState([]);
  const [addingCat3, setAddingCat3] = useState(false);
  const [bomBtnDisable, setbomBtnDisable] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    if (logInRights) {
      setUserRights(logInRights);
    }
  }, [logInRights]);
  const MasterAddEditAccess = CheckActionPermission(userRights, 'masters', 'names', 'addEdit');

  useEffect(() => {
    if (scrollEl) {
      scrollEl.scrollTop = 1000;
    }
  }, [scrollEl]);

  useEffect(() => {
    if (!category3ListFrom4) {
      setBomCompTypeData(bomSubComponentType);
      if (addingCat3) {
        setBomCompTypeData([
          ...bomSubComponentType,
          {
            name: null,
            isEmpty: false,
            isNew: true,
            isActive: true,
            hasLength: false,
            _id: '',
          },
        ]);
      }
    }
  }, [bomSubComponentType, category3ListFrom4, addingCat3]);

  const callApi = async () => {
    setButtonDownBomType(!buttonDownBomType);
    setIsLoadingBSTM(true);
    buttonDownBomType ? setShowBomType(true) : setShowBomType(false);
    const bomTypeparams = {
      isAllRecord: true,
    };
    !bomSubCompTypeData.length && (await dispatch(action.getBOMTypeDetails(bomTypeparams)));
    setIsLoadingBSTM(false);
  };

  const handleChanged = (event, i) => {
    const bomST = [...bomCompTypeData];
    bomST[i] = {
      ...bomST[i],
      name: event.target.value,
      isEmpty: event.target.value === '',
      bomTypeID: bomSubTypeSelectData?._id,
      bomsubTypeId: bomCompData?._id,
    };
    setIsBomTypeUnique(true);
    setIsUniqBTDId([]);
    const BtDarray = [];
    const BTDarrayIndex = [];
    bomST?.forEach((ele, ind) => {
      bomST?.forEach((objs, index) => {
        if (ele.name === objs.name && ind !== index) {
          BtDarray.push(ele);
          BTDarrayIndex.push(index);
        }
      });
    });
    if (!isEmpty(BtDarray)) {
      const arrs = [...BTDarrayIndex];
      const removeArss = Math.min(...arrs);
      const newArr = BTDarrayIndex.filter((ele) => ele !== removeArss);
      setIsUniqBTDId([...newArr]);
    }
    setIsBomTypeUnique(isEmpty(BtDarray));
    let disabled = false;
    bomST.forEach((ele) => {
      if (isEmpty(ele?.name?.trim())) {
        disabled = true;
      }
    });
    setbomBtnDisable(disabled);
    setBomCompTypeData(bomST);
  };

  const handleCompDelete = (id) => {
    if (typeof id === 'number' || id === '') {
      bomCompTypeData.splice(id, 1);
      setIsBomTypeUnique(true);
      setIsUniqBTDId([]);
      setBomCompSubTypeData([...bomCompTypeData]);
    } else {
      setDeleteId(id);
      setShowConfirmation(true);
    }
  };

  useEffect(() => {
    bomSubTypeSelectData && Object.keys(bomSubTypeSelectData).length && bomSubTypeCalled();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bomSubTypeSelectData]);

  const bomSubTypeCalled = async () => {
    const bomsubTypeParams = {
      bomTypeId: bomSubTypeSelectData._id,
      componentTypeId: bomCompData?._id || '',
      _id: bomCompTypeData?._id,
      loggedInUserId,
      fromBomCompType: true,
    };
    await dispatch(action.getBOMSubTypeDetails(bomsubTypeParams));
  };
  const bomSubChildCalled = async (value) => {
    const bomChildTypeParams = {
      bomTypeId: bomSubTypeSelectData._id,
      componentTypeId: value?._id || bomCompData?._id,
      _id: bomCompTypeData?._id,
      loggedInUserId,
      fromBomCompType: true,
    };
    await dispatch(action.getBOMTypeComponentDetails(bomChildTypeParams));
    setLoader(false);
  };

  const saveComponentBOMST = async () => {
    setIsBOMST(true);
    if (!isEmpty(bomCompTypeData)) {
      const emptyField = bomCompTypeData.filter((bomsitem) => bomsitem.name === null || bomsitem.name === '');
      if (isEmpty(emptyField)) {
        const data = bomCompTypeData.map((bomstobj) => ({
          ...bomstobj,
          name: bomstobj?.name?.trim(),
          _id: bomstobj?._id,
        }));
        const bomstparams = {
          names: JSON.stringify(data),
          isDeleted: false,
          isActive: true,
          bomTypeId: bomSubTypeSelectData._id,
          componentTypeId: bomCompData?._id || '',
          title: 'component-sub-type-master',
        };
        setAddingCat3(false);

        await dispatch(action.saveToSystemMaster(bomstparams, t));
        await bomSubChildCalled();
      } else {
        const newState = bomCompTypeData.map((bomsobj) => (bomsobj?.isEmpty === false && bomsobj.name === null ? { ...bomsobj, isEmpty: true } : bomsobj));
        setBomCompSubTypeData(newState);
      }
    }
    setIsBOMST(false);
  };

  const activeInactiveClicked = (id) => {
    setShowConfirmationAD(true);
    setActiveInactiveID(id);
  };
  const deleteConfirmed = async () => {
    setIsLoadingConf(true);
    const bomTypeDataParams = {
      loggedInUserId,
      compSubTypeId: deleteId,
      title: 'component-sub-type-master',
    };
    await dispatch(action.deleteFromSystemMasters(bomTypeDataParams, t));
    setIsLoadingConf(false);
    setShowConfirmation(false);
    setBomCompSubTypeData([...BOMComTypeList]);
    await bomSubTypeCalled();
    await bomSubChildCalled();
  };
  const activeInactiveConfirmed = async () => {
    setIsLoadingConf(true);
    let btd = {};
    bomCompTypeData?.forEach((ele) => {
      if (ele._id === activeInactiveID) {
        ele.isActive = !ele.isActive;
        const data = {
          ...ele,
          loggedInUserId,
          title: 'component-sub-type-master',
          id: ele._id,
        };
        btd = data;
      }
    });
    await dispatch(action.setActiveInactive(btd, t));
    setIsLoadingConf(false);
    setShowConfirmationAD(false);
    setBomCompSubTypeData([...bomCompTypeData]);
  };

  useEffect(() => {
    const array = [];
    bomCompTypeData?.forEach((ele, index) => {
      bomCompTypeData?.forEach((obj, places) => {
        if (index !== places && ele?.name === obj?.name) {
          array.push(ele);
        }
      });
    });
    if (isEmpty(array)) {
      setIsBomTypeUnique(isEmpty(array));
      setIsUniqBTDId([]);
    }
  }, [bomCompTypeData]);
  const addBOMST = async () => {
    if (!showBomType) {
      setAddingCat3(true);
      setButtonDownBomType(!buttonDownBomType);
      setIsLoadingBSTM(true);
      buttonDownBomType ? setShowBomType(true) : setShowBomType(false);
      const bomTypeparams = {
        isAllRecord: true,
        loggedInUserId,
        bomTypeId: bomSubTypeSelectData._id,
        componentTypeId: bomCompData?._id || '',
        _id: bomCompTypeData?._id,
      };

      !showBomType && (await dispatch(action.getBOMTypeComponentDetails(bomTypeparams)));
      setIsLoadingBSTM(false);
    } else if (!isEmpty(bomCompTypeData)) {
      setBomCompTypeData([...bomCompTypeData, tempObj]);
    } else {
      setBomCompTypeData([tempObj]);
    }
  };
  const btnCall = () => {
    if (buttonDownBomType === false) {
      return <i className="icon-new-up" />;
    }
    return <i className="icon-new-down" />;
  };
  const saveCompBmst = () => {
    return isBOMST ? (
      <Spinner animation="border" />
    ) : (
      <>
        <span className="icon-Save c-button-align f-20 mr-2" /> {t('BOM_TYPE_MASTER.SAVE')}
      </>
    );
  };

  const renderTooltipOpenCloseBomType = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {!buttonDownBomType ? 'Close' : 'Open'}
    </Tooltip>
  );
  const renderTooltipActiveInactive = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {t('BOM_TYPE_MASTER.ACTIVATE_INACTIVATE')}
    </Tooltip>
  );
  const renderTooltipCompDelete = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {t('BOM_TYPE_MASTER.DELETE')}
    </Tooltip>
  );
  const handleDropdownChangeBomType = (value) => {
    setbomSubTypeSelectData(value);
    setBomCompData(null);
  };
  const handleDropdownChange = (value) => {
    setLoader(true);
    setBomCompData(value);
    bomSubChildCalled(value);
  };
  return (
    <>
      <Accordion className="mb-4 master-accordian">
        <Card>
          <Card.Header>
            <div className="title-container">
              <p>{t('BOM_TYPE_MASTER.BOM_SUB_COMPONENT_TYPE')}</p>
            </div>
            <div className={!MasterAddEditAccess ? 'action-title-btns single-btn' : 'action-title-btns'}>
              <BtnAdd onBtnClick={addBOMST} forDisable={bomBtnDisable || !isBomTypeUnique} addEditAccess />
              <OverlayTrigger placement="auto" delay={{ show: 250, hide: 400 }} overlay={renderTooltipOpenCloseBomType}>
                <button type="button" onClick={() => callApi()}>
                  {btnCall()}
                </button>
              </OverlayTrigger>
            </div>
          </Card.Header>
          {showBomType &&
            (isLoadingBSTM ? (
              <Loader />
            ) : (
              <Card.Body>
                <div className="select-container">
                  <Select
                    options={BOMTypeList}
                    placeholder={t('BOM_TYPE_MASTER.SELECT_BOM_TYPE')}
                    getOptionLabel={(option) => `${option.name}`}
                    getOptionValue={(option) => `${option._id}`}
                    name="bomsubtype"
                    value={bomSubTypeSelectData}
                    styles={SelectBoxStyles}
                    maxMenuHeight={130}
                    className="common-select"
                    classNamePrefix="common-select"
                    onChange={handleDropdownChangeBomType}
                  />
                  <Select
                    options={BOMComTypeList}
                    placeholder={t('BOM_TYPE_MASTER.SELECT_SUB_BOM_TYPE')}
                    getOptionLabel={(option) => `${option.name}`}
                    getOptionValue={(option) => `${option._id}`}
                    name="bomTypeData"
                    maxMenuHeight={130}
                    styles={SelectBoxStyles}
                    className="common-select"
                    classNamePrefix="common-select"
                    value={bomCompData}
                    onChange={(e) => handleDropdownChange(e)}
                  />
                </div>
                {loader ? (
                  <Loader />
                ) : (
                  <PerfectScrollbar
                    containerRef={(ref) => {
                      setScrollEl(ref);
                    }}
                  >
                    <ul>
                      {bomCompTypeData &&
                        bomCompData &&
                        bomSubTypeSelectData &&
                        Object.keys(bomCompData).length !== 0 &&
                        Object.keys(bomSubTypeSelectData).length !== 0 &&
                        Array.isArray(bomCompTypeData) &&
                        !isEmpty(bomCompTypeData) &&
                        bomCompTypeData?.map((boms, bomsIndex) => {
                          return (
                            <li key={boms?._id}>
                              <div className="input-container">
                                <input
                                  name="bomCompTypeData"
                                  value={boms.name ? boms.name : ''}
                                  type="text"
                                  autoFocus={!boms?._id}
                                  placeholder={t('BOM_TYPE_MASTER.ENTER_BOM_SUB_COMPONENT_TYPE')}
                                  onChange={(e) => handleChanged(e, bomsIndex)}
                                />
                                {!isEmpty(isUniqBTDId) && isUniqBTDId.includes(bomsIndex) && (
                                  <label className="text-danger m-0 p-1">{t('BOM_TYPE_MASTER.ENTRY_ALREADY_EXIST')}</label>
                                )}

                                {boms?.isEmpty && (boms?.name === null || boms?.name === '') && (
                                  <label className="text-danger m-0 p-1">{t('BOM_TYPE_MASTER.BOM_SUB_TYPE_REQUIRED')}</label>
                                )}
                                {boms?.isNew && !isEmpty(boms?.name) && isEmpty(boms?.name?.trim()) && (
                                  <label className="text-danger m-0 p-1">{t('BOM_TYPE_MASTER.INVALID_BOM_SUB_TYPE')}</label>
                                )}
                              </div>
                              <div className="input-action">
                                {boms?._id && (
                                  <OverlayTrigger placement={t('BOM_TYPE_MASTER.AUTO')} delay={{ show: 250, hide: 400 }} overlay={renderTooltipActiveInactive}>
                                    <button onClick={() => activeInactiveClicked(boms?._id)} id={boms?._id}>
                                      <span className={boms.isActive ? 'icon-active' : 'icon-inactive'} />
                                    </button>
                                  </OverlayTrigger>
                                )}

                                <OverlayTrigger placement={t('BOM_TYPE_MASTER.AUTOS')} delay={{ show: 250, hide: 400 }} overlay={renderTooltipCompDelete}>
                                  <button
                                    onClick={() => {
                                      handleCompDelete(boms?._id ? boms?._id : bomsIndex);
                                    }}
                                  >
                                    <span className="icon-delete mt-3 f-20" />
                                  </button>
                                </OverlayTrigger>
                              </div>
                            </li>
                          );
                        })}
                    </ul>
                  </PerfectScrollbar>
                )}
                <div className="section-save">
                  {/* {MasterAddEditAccess && ( */}
                  <CustomTooltip tooltipText={t('common:COMMON_LABEL.SAVE')}>
                    <button
                      aria-label="Save"
                      className="btn btn-page-filter btn-white"
                      onClick={saveComponentBOMST}
                      disabled={bomBtnDisable || !isBomTypeUnique}
                    >
                      {saveCompBmst()}
                    </button>
                  </CustomTooltip>
                  {/* )} */}
                </div>
              </Card.Body>
            ))}
        </Card>
      </Accordion>
      {showConfirmation && (
        <ConfirmationPopup
          onOpen={showConfirmation}
          onConfirm={() => deleteConfirmed()}
          title={t('BOM_TYPE_MASTER.DELETE_FROM_SYSTEM_MASTER')}
          message={t('BOM_TYPE_MASTER.ARE_YOU_SURE_DELETE_ITEM')}
          toggle={() => {
            setShowConfirmation(!showConfirmation);
          }}
          loading={isLoadingConf}
        />
      )}
      {showConfirmationAD && (
        <ConfirmationPopup
          onOpen={showConfirmationAD}
          onConfirm={() => activeInactiveConfirmed()}
          title={t('BOM_TYPE_MASTER.ACTIVATE_DEACTIVATE')}
          message={t('BOM_TYPE_MASTER.ARE_YOU_SURE_ACTIVATE_DEACTIVATE')}
          toggle={() => {
            setShowConfirmationAD(!showConfirmationAD);
          }}
          loading={isLoadingConf}
        />
      )}
    </>
  );
}
export default BomSubComponentTypeMaster;
